module.exports = __webpack_public_path__ + "static/media/tg.e602a907.svg";